import { useState, useEffect, useRef } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import MessageItem from 'app/components/MessageItem'
import QuestionItem from 'app/components/QuestionItem'
import { SearchIcon } from 'app/components/icons'
import { setHelpTabInputFocus, setWidgetTab } from 'app/redux/widget/widget.actions'
import useDelayUnmount from 'app/hooks/useDelayUnmount'
import CloseWidgetBtn from 'app/components/CloseWidgetBtn'
import CoverLogo from 'app/components/CoverLogo'
import clsx from 'clsx'
import './home.scss'
import ClamedText from 'app/components/ClampedText'

const getWidgetInfo = ({ widgetData }) => widgetData.widgetInfo
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo
const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data.teams
const getFaqs = ({ widgetData }) => widgetData.widgetInfo.faq

const Home = ({ ct, setShowGreetingAvatars, showGreetingAvatars }) => {
  const headerCollectionRef = useRef(null)
  const coverBodyRef = useRef(null)

  const widgetInfo = useSelector(getWidgetInfo)
  const languageInfo = useSelector(getLanguageInfo)
  const departments = useSelector(getDepartments)
  const faqs = useSelector(getFaqs)

  const faqsEnabled = !!faqs.length && faqs.some((item) => item.questions.length)
  const direction = languageInfo?.general?.direction || 'rtl'
  const dispatch = useDispatch()
  const [isMounted, setIsMounted] = useState(ct === 0)
  const shouldRenderChild = useDelayUnmount(isMounted, 200)
  // const smallWidth = useMediaQuery("(max-width: 700px)");

  const title = widgetInfo.data.personalize.title

  const customCssVariables = {
    '--raychat-cover-logo': `url(${widgetInfo.data.coverIcon})`,
    '--raychat-direction': direction === 'rtl' ? 'right' : 'left',
  }

  const handleSelectHelpTab = () => {
    dispatch(setWidgetTab(2))
    setTimeout(() => {
      dispatch(setHelpTabInputFocus(true))
    }, 300)
  }

  const getShowcaseQuestions = () => {
    let selectedQuestions = []

    faqs.forEach((faq) => {
      faq.questions?.forEach((q, i) => {
        if (i < 1) selectedQuestions.push(q)
      })
    })

    return selectedQuestions.slice(0, 4)
  }

  useEffect(() => {
    if (ct !== 0) {
      setIsMounted(false)
    } else {
      setIsMounted(true)
    }
  }, [ct])

  useEffect(() => {
    if (!shouldRenderChild) {
      setIsMounted(ct === 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRenderChild])

  useEffect(() => {
    const titleCollectionHeight = headerCollectionRef.current?.clientHeight
    const coverBodyHeight = coverBodyRef.current?.clientHeight

    const sumHeight = coverBodyHeight + titleCollectionHeight

    if (!isNaN(sumHeight) && sumHeight < 520 && !showGreetingAvatars) setShowGreetingAvatars(true)
  })

  if (!shouldRenderChild) return null

  return (
    <div
      className={clsx(isMounted ? 'component_enter' : 'component_exit', 'home_tab__wrapper')}
      style={customCssVariables}
    >
      <div className="home_tab">
        <div ref={headerCollectionRef} className="cover_header">
          <div className="cover_header_logo_title_wrapper">
            <div className="cover_header_logo_close_container">
              <div className="cover_header_logo_container">
                <CoverLogo customClass="cover_header_logo__default_logo" />
              </div>
            </div>

            <CloseWidgetBtn />
          </div>
          <p title={title} className="cover_header_title">
            <ClamedText text={title} linesNum={3} maxChar={105} />
          </p>
        </div>

        <div className="cover_body">
          <div ref={coverBodyRef}>
            <div className="cover_departments">
              {departments?.length > 1 ? (
                <ul className="cover_departments_all_wrapper">
                  {departments.map((department) => (
                    <MessageItem key={department._id} department={department} />
                  ))}
                </ul>
              ) : null}
            </div>

            {faqsEnabled && (
              <div className="cover_questions">
                {/* Search box */}
                <div onClick={handleSelectHelpTab} className="cover_questions_search_box">
                  <span className="cover_questions_search_box_title">{languageInfo.texts.search}</span>

                  <div className="cover_questions_search_box_icon">
                    <SearchIcon />
                  </div>
                </div>

                {/* render only last question of each FAQ ( just 4 question ) */}
                <div className="cover_faq_questions_wrapper">
                  {getShowcaseQuestions().map((q, i) => (
                    <QuestionItem question={q} key={i} />
                  ))}
                </div>
                {getShowcaseQuestions().length === 0 && <span>{languageInfo.texts.questionNotFound}</span>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
